const keyFor = (cycleId) => `piers:inspection-cycle-setup:${cycleId}`;

export const markCycleSetupPending = (cycleId) => {
  if (cycleId && typeof window !== "undefined")
    window.sessionStorage.setItem(keyFor(cycleId), "true");
};

export const isCycleSetupPending = (cycleId) =>
  Boolean(
    cycleId &&
      typeof window !== "undefined" &&
      window.sessionStorage.getItem(keyFor(cycleId)) === "true"
  );

export const clearCycleSetupPending = (cycleId) => {
  if (cycleId && typeof window !== "undefined")
    window.sessionStorage.removeItem(keyFor(cycleId));
};
